/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FollowNotificationAction } from './FollowNotificationAction';
import {
    FollowNotificationActionFromJSON,
    FollowNotificationActionFromJSONTyped,
    FollowNotificationActionToJSON,
} from './FollowNotificationAction';

/**
 * 
 * @export
 * @interface FollowNotification
 */
export interface FollowNotification {
    /**
     * 
     * @type {string}
     * @memberof FollowNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof FollowNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof FollowNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof FollowNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<FollowNotificationAction>}
     * @memberof FollowNotification
     */
    actions: Array<FollowNotificationAction>;
}

/**
 * Check if a given object implements the FollowNotification interface.
 */
export function instanceOfFollowNotification(value: object): value is FollowNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function FollowNotificationFromJSON(json: any): FollowNotification {
    return FollowNotificationFromJSONTyped(json, false);
}

export function FollowNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FollowNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(FollowNotificationActionFromJSON)),
    };
}

export function FollowNotificationToJSON(value?: FollowNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(FollowNotificationActionToJSON)),
    };
}

